import React from 'react'
import { DividerSlice } from 'modules/prismic'

export const Divider = ({ primary }: DividerSlice) => {
  const { size } = primary
  return (
    <div
      style={{
        marginTop: sizeOptionsMargin[size]
      }}
    />
  )
}

const sizeOptionsMargin = {
  Default: '8vw',
  Small: '5vw',
  Large: '10vw'
}
